import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { blogPosts } from '../data/blog';
import { JsonLd, useSEO } from '../utils/seo';
export function Blog() {
  useSEO({
    title: 'Gravel, Driveway & Landscaping Guides | 206Gravel',
    description: 'Practical guides for choosing gravel, building driveways, improving drainage, and planning bulk material delivery in the Puget Sound area.',
    path: '/blog'
  });
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <main className="pt-24 pb-20 bg-[#f] dark:bg-[#252423] min-h-screen" data-id="element-2002" data-mp="3uflqn2urco3l">
      <JsonLd data={{
      '@context': 'https://schema.org',
      '@type': 'Blog',
      name: '206Gravel Guides & Tips',
      url: 'https://206gravel.com/blog',
      blogPost: blogPosts.map(post => ({
        '@type': 'BlogPosting',
        headline: post.title,
        datePublished: post.date,
        image: post.image,
        url: `https://206gravel.com/blog/${post.slug}`,
        description: post.excerpt
      }))
    }} data-id="element-2003" data-mp="cxsp7kmajoeb" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2004" data-mp="2253xs43nx5ol">
        {/* Header mirrors the Materials Hub / Project Guides sections: accent
            rule, oversized two-tone heading, an eyebrow, and one line of
            orientation copy. */}
        <header className="mb-10 md:mb-12" data-id="element-2005" data-mp="2fxaepsen3gp3">
          <motion.div initial={{
          width: 0,
          opacity: 0
        }} animate={{
          width: 64,
          opacity: 1
        }} transition={{
          duration: 0.65,
          ease: [0.22, 1, 0.36, 1]
        }} className="mb-7 h-1 rounded-full bg-brand-orange" data-id="element-2006" data-mp="2fvz6nge5vms6" />
          <div className="mb-5 flex flex-col gap-3 md:flex-row md:items-baseline md:gap-7" data-id="element-2007" data-mp="1s5ms3moeursm">
            <motion.h1 initial={{
            opacity: 0,
            y: 18
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            type: 'spring',
            stiffness: 200,
            damping: 20
          }} className="font-heading text-5xl font-extrabold leading-[1.1] tracking-tight text-brand-charcoal dark:text-white md:text-6xl lg:text-7xl" data-id="element-2008" data-mp="1x72cdcirku9y">
              Gravel <span className="font-black text-[#04A05C]" data-id="element-2009" data-mp="14h1tvn8r1wgp">Guides</span>
            </motion.h1>
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#17A348]" data-id="element-2010" data-mp="1iguhvasw5ykz">
              — Tips &amp; how-tos
            </span>
          </div>
          <p className="max-w-2xl font-sub text-lg font-medium leading-relaxed tracking-wide text-brand-charcoal dark:text-white" data-id="element-2011" data-mp="ps5pc05wj1ku">
            Straight answers on picking the right material, building a driveway
            that lasts, fixing drainage, and planning a bulk delivery — written
            from what we haul every day around Puget Sound.
          </p>
        </header>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-2012" data-mp="727h9k23t8h7">
          {blogPosts.map((post, idx) => <motion.article key={post.slug} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: idx * 0.1
        }} className="bg-white dark:bg-[#333333] rounded-2xl overflow-hidden shadow-sm border border-stone-200 dark:border-white/10 hover:shadow-md transition-shadow flex flex-col" data-id="element-2013" data-mp="23e1tm39b7ee" data-mpi={idx}>
              <Link to={`/blog/${post.slug}`} className="block aspect-video overflow-hidden" data-id="element-2014" data-mp="28rd2bhqtgu3q">
                <img src={post.image} alt={post.title} className="w-full h-full object-cover hover:scale-105 transition-transform duration-500" data-id="element-2015" data-mp="28p0q7l7qpdyl" />
              </Link>
              <div className="p-6 flex flex-col flex-grow" data-id="element-2016" data-mp="31fipsc998x79">
                <p className="text-sm text-brand-muted dark:text-stone-400 italic mb-2" data-id="element-2017" data-mp="2ngstgyu9f1jy">
                  {post.date}
                </p>
                <Link to={`/blog/${post.slug}`} data-id="element-2018" data-mp="2sdszxav0u6bl">
                  <h2 className="font-heading text-xl font-extrabold text-brand-charcoal dark:text-white uppercase mb-3 hover:text-brand-orange transition-colors" data-id="element-2019" data-mp="1c1dx9x9vkdpw">
                    {post.title}
                  </h2>
                </Link>
                <p className="text-brand-muted dark:text-stone-300 text-sm leading-relaxed flex-grow" data-id="element-2020" data-mp="1wbf1l21i869x">
                  {post.excerpt}
                </p>
              </div>
            </motion.article>)}
        </div>
      </div>
    </main>;
}